class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* Fithome: la barra superior fija ("Para envíos fuera de España...") pasa a dos líneas en móviles
   estrechos y tapaba el header. Este código:
   - ajusta el espacio de la página a la altura real de la barra (también al girar o redimensionar);
   - coloca el header justo debajo de la barra, también al hacer scroll, teniendo en cuenta el
     desplazamiento propio que ya trae el header en la portada;
   - anula el relleno extra fijo (67px / 80px de custom-new.css) que se añadía al header al hacer
     scroll, para que el header mantenga su altura normal.
   Va en este archivo porque el header lo carga en todas las páginas. */
(function () {
  var style = document.createElement('style');
  style.textContent =
    'html body .shopify-section.shopify-section-group-header-group.section-header.shopify-section-header-sticky.scrolled-past-header .header{padding-top:var(--fh-hdr-pt,22px)!important}';
  document.head.appendChild(style);

  function fhSyncBar() {
    var bar = document.getElementById('custom-top-announcement-bar');
    if (!bar || !document.body) return;
    var h = Math.round(bar.getBoundingClientRect().height);
    if (window.getComputedStyle(bar).display === 'none') h = 0;
    document.documentElement.style.setProperty('--fh-bar-h', h + 'px');
    document.body.style.paddingTop = h + 'px';
    var sticky = document.querySelector('.section-header');
    if (!sticky) return;
    var hdr = sticky.querySelector('header.header') || sticky.querySelector('.header');
    if (hdr) {
      /* Se mide el relleno normal del header sin la clase de scroll (y sin la transición), para que
         sirva aunque la página se cargue o cambie de tamaño estando ya bajada. */
      var was = sticky.classList.contains('scrolled-past-header');
      var tr = hdr.style.transition;
      hdr.style.transition = 'none';
      if (was) sticky.classList.remove('scrolled-past-header');
      document.documentElement.style.setProperty('--fh-hdr-pt', window.getComputedStyle(hdr).paddingTop);
      if (was) sticky.classList.add('scrolled-past-header');
      void hdr.offsetHeight;
      hdr.style.transition = tr;
    }
    var inner = hdr ? Math.round(hdr.getBoundingClientRect().top - sticky.getBoundingClientRect().top) : 0;
    if (inner < 0) inner = 0;
    sticky.style.top = Math.max(0, h - inner) + 'px';
  }
  window.addEventListener('resize', fhSyncBar);
  window.addEventListener('orientationchange', fhSyncBar);
  window.addEventListener('load', fhSyncBar);
  document.addEventListener('DOMContentLoaded', fhSyncBar);
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var bar = document.getElementById('custom-top-announcement-bar');
    if (bar) {
      clearInterval(timer);
      fhSyncBar();
      if (window.ResizeObserver) new ResizeObserver(fhSyncBar).observe(bar);
    } else if (tries > 50) {
      clearInterval(timer);
    }
  }, 200);
})();

/* Fithome: selector propio de país e idioma (ventana "Selecciona tu país e idioma", layout/theme.liquid).
   El tema elegía el mercado a partir de la MONEDA del país (tabla akCountryCodeByCurrencyCode), y eso
   fallaba: todos los países en euros (Francia, Alemania, Italia, Portugal...) acababan en el mercado de
   España, varios países en dólares iban a Norteamérica, España + Español llevaba al inglés y algunas
   combinaciones daban 404 (/ca-fr/, /es-fr/...).
   Este código decide la dirección a partir del PAÍS elegido (su código ISO) y de los mercados de Shopify:
   - España: español sin prefijo, /ca/ o /en/.
   - México (USD): /es-mx/ o /en-mx/.  Américas: /en-am/ o /es-am/.  Portugal: /en-pt/ o /es-pt/.
   - Resto de mercados: /en-xx/ (solo tienen inglés).
   - Si el idioma elegido no existe en ese mercado, se usa el idioma principal del mercado.
   - Países que no están en ningún mercado: web de España en el idioma elegido.
   También muestra "Mexico (USD)" en la lista y ofrece el español en los países de Américas y Portugal,
   que tienen la web en español. Si cambian los mercados en Shopify hay que actualizar FH_MARKETS. */
(function () {
  var FH_MARKETS = {
    as: { langs: ['en'], countries: 'KH TL ID LA MO MY PH KR TW TH VN' },
    me: { langs: ['en'], countries: 'AM AZ BH BD BT GE IN IL JO KW LB LY MA NP OM PK PS QA SA AE LK TN' },
    am: { langs: ['en', 'es'], countries: 'AG AI AR AW BS BB BZ BO BR VG KY CL CO CR CW DM DO EC SV GF GD GP GT GY HT HN JM MQ MS NI PA PY PE KN SX VC SR TT TC UY VE' },
    ee: { langs: ['en'], countries: 'HU RO RS GR CZ SK SI BA BG PL' },
    fr: { langs: ['en'], countries: 'FR' },
    ir: { langs: ['en'], countries: 'IE' },
    it: { langs: ['en'], countries: 'IT' },
    meu: { langs: ['en'], countries: 'DK DE BE LU AT CH' },
    mx: { langs: ['es', 'en'], countries: 'MX' },
    na: { langs: ['en'], countries: 'CA US' },
    pt: { langs: ['en', 'es'], countries: 'PT' },
    '': { langs: ['es', 'ca', 'en'], countries: 'ES' }
  };
  var FH_ISO = {};
  Object.keys(FH_MARKETS).forEach(function (k) {
    FH_MARKETS[k].countries.split(' ').forEach(function (c) { FH_ISO[c] = k; });
  });

  function fhIsoOf(countryName) {
    var a = document.querySelector('a[data-country="' + String(countryName).replace(/"/g, '') + '"][data-country-code]');
    return a ? a.getAttribute('data-country-code').toUpperCase() : '';
  }

  /* Países que Shopify cobra en dólares (México, y en Américas los que no tienen su moneda en Shopify
     Payments: Argentina, Brasil, Chile, Colombia). En la lista se muestra (USD) en vez de su moneda. */
  var FH_USD = ['Mexico', 'Argentina', 'Brazil', 'Chile', 'Colombia'];
  function fhFixOptions() {
    document.querySelectorAll(FH_USD.map(function (c) { return 'a[data-country="' + c + '"]'; }).join(',')).forEach(function (a) {
      a.setAttribute('data-currency', 'USD');
      a.setAttribute('data-currency-code', 'usd');
      var s = a.querySelector('.small-currency');
      if (s) s.textContent = '(USD)';
    });
    try {
      if (window.akCurrencies) {
        FH_USD.forEach(function (c) {
          if (window.akCurrencies[c]) {
            window.akCurrencies[c].currency_code = 'usd';
            window.akCurrencies[c].currency_label = 'USD';
          }
        });
        Object.keys(window.akCurrencies).forEach(function (name) {
          var m = FH_ISO[fhIsoOf(name)];
          var c = window.akCurrencies[name];
          if (m === undefined || !c || !c.languages) return;
          FH_MARKETS[m].langs.forEach(function (l) {
            if (c.languages.indexOf(l) === -1) c.languages.push(l);
          });
        });
      }
    } catch (e) {}
  }

  function fhBuildPath(locale) {
    var path = window.location.pathname.replace(/^\/(en|es|ca)(-[a-z]{2,3})?(?=\/|$)/i, '');
    if (path === '') path = '/';
    var country = '';
    try { country = localStorage.getItem('akSelectedCountry_') || ''; } catch (e) {}
    var iso = fhIsoOf(country);
    var suffix = FH_ISO[iso];
    var cc = suffix === undefined ? 'ES' : iso;
    if (suffix === undefined) suffix = '';
    var langs = FH_MARKETS[suffix].langs;
    if (langs.indexOf(locale) === -1) locale = langs[0];
    var prefix = suffix ? '/' + locale + '-' + suffix : (locale === 'es' ? '' : '/' + locale);
    return { path: prefix + path, locale: locale, iso: iso, cc: cc };
  }

  /* Desplegable de idioma del header (escritorio) y del pie de página (ak-custom.js): cambiaba solo
     /en/, /es/ o /ca/ y, en un mercado con subcarpeta (/en-fr/, /es-mx/...), creaba direcciones como
     /ca/en-fr/... que dan 404. Aquí se cambia el idioma manteniendo el mercado actual y, si ese idioma
     no existe en el mercado, se usa su idioma principal. */
  function fhSwitchLanguage(lang) {
    var m = window.location.pathname.match(/^\/(en|es|ca)(?:-([a-z]{2,3}))?(?=\/|$)/i);
    var suffix = m && m[2] ? m[2].toLowerCase() : '';
    if (!FH_MARKETS[suffix]) suffix = '';
    var langs = FH_MARKETS[suffix].langs;
    if (langs.indexOf(lang) === -1) lang = langs[0];
    var rest = window.location.pathname.replace(/^\/(en|es|ca)(-[a-z]{2,3})?(?=\/|$)/i, '') || '/';
    var prefix = suffix ? '/' + lang + '-' + suffix : (lang === 'es' ? '' : '/' + lang);
    try { localStorage.setItem('fithome_selected_language', lang); } catch (e) {}
    window.location.href = window.location.origin + prefix + rest + window.location.search + window.location.hash;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-language-code]') : null;
    if (!a || !a.closest('.ak-header-currency-lang-right, .footer, footer')) return;
    if (a.closest('#AK-modal')) return;
    var lang = (a.getAttribute('data-language-code') || '').toLowerCase();
    if (['es', 'en', 'ca'].indexOf(lang) === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fhSwitchLanguage(lang);
  }, true);

  function fhWrapLocaleUrl() {
    if (typeof window.updateLocaleUrl !== 'function') return false;
    if (window.updateLocaleUrl.__fh) return true;
    var wrapped = function (locale, countryCode, s) {
      locale = (locale || 'es').toLowerCase();
      if (['es', 'en', 'ca'].indexOf(locale) === -1) locale = 'en';
      var target = fhBuildPath(locale);
      try {
        localStorage.setItem('fithome_selected_language', target.locale);
        if (target.iso) localStorage.setItem('fithome_selected_country', target.iso);
      } catch (e) {}
      if (s === true) {
        try { localStorage.setItem('updateLocaleUrl_', target.path + (target.cc ? '?country=' + target.cc : '')); } catch (e) {}
        return;
      }
      /* Se añade ?country=XX para que Shopify use el país elegido (precio, moneda y stock de ese país).
         Sin esto Shopify se quedaba con el país anterior guardado en la cookie, y por ejemplo Argentina
         salía en dólares y como agotada. */
      var qs = window.location.search.replace(/^\?/, '').split('&').filter(function (p) { return p && !/^country=/i.test(p); });
      if (target.cc) qs.push('country=' + target.cc);
      window.location.href = window.location.origin + target.path + (qs.length ? '?' + qs.join('&') : '') + window.location.hash;
    };
    wrapped.__fh = true;
    window.updateLocaleUrl = wrapped;
    return true;
  }
  function fhRun() {
    fhFixOptions();
    return fhWrapLocaleUrl();
  }

  /* Shopify guarda el país en una cookie y a veces no coincide con la web en la que se está (por ejemplo
     la web de España mostrando precios en dólares y productos agotados porque la cookie dice Islas
     Vírgenes, o /es-am/ usando las Islas Vírgenes en vez de Argentina). Si el país que usa Shopify no es
     de este mercado, o no es el que eligió el cliente, se recarga una vez la página con ?country=XX:
     el país elegido si es de este mercado, y si no, el país principal del mercado (España en la web sin
     prefijo). */
  var FH_DEFAULT = { '': 'ES', mx: 'MX', fr: 'FR', ir: 'IE', it: 'IT', pt: 'PT', na: 'US', meu: 'DE', ee: 'PL', me: 'AE', as: 'KR', am: 'AR' };
  (function fhSyncCountry() {
    try {
      var cur = window.Shopify && Shopify.country ? String(Shopify.country).toUpperCase() : '';
      if (!cur) return;
      var m = window.location.pathname.match(/^\/(en|es|ca)(?:-([a-z]{2,3}))?(?=\/|$)/i);
      var suffix = m && m[2] ? m[2].toLowerCase() : '';
      if (!FH_MARKETS[suffix]) return;
      var want = (localStorage.getItem('fithome_selected_country') || '').toUpperCase();
      var target = '';
      if (want && FH_ISO[want] === suffix) target = want;
      else if (FH_ISO[cur] !== suffix) target = FH_DEFAULT[suffix];
      if (!target || target === cur) return;
      if (/[?&]country=/i.test(window.location.search)) return;
      var key = 'fh_cc_' + target + '_' + suffix;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      window.location.replace(window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'country=' + target + window.location.hash);
    } catch (e) {}
  })();
  document.addEventListener('DOMContentLoaded', fhRun);
  window.addEventListener('load', fhRun);
  var n = 0;
  var t = setInterval(function () {
    n++;
    var done = fhRun() && document.querySelector('a[data-country="Mexico"]');
    if (done || n > 60) clearInterval(t);
  }, 250);
})();

/* Fithome: en la ventana "Selecciona tu país e idioma" los países se muestran en el idioma elegido en el
   desplegable de idioma de esa misma ventana (al abrirla, el de la página): España / Espanya / Spain,
   ordenados alfabéticamente. Solo cambia el texto visible: data-country sigue en inglés porque el tema lo
   usa como clave. */
(function () {
  function norm2(l) { l = (l || 'es').slice(0, 2).toLowerCase(); return ['es', 'ca', 'en'].indexOf(l) === -1 ? 'en' : l; }
  var lang = norm2(document.documentElement.lang);
  var dn = null;
  var names = {};
  var rev = {};
  var sortedLang = '';
  function makeDn() { try { dn = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) { dn = null; } }
  makeDn();
  function localName(a) {
    var code = (a.getAttribute('data-country-code') || '').toUpperCase();
    if (!code || !dn) return '';
    var n = '';
    try { n = dn.of(code); } catch (e) {}
    return n && n !== code ? n : '';
  }
  function fhLocalizeCountries() {
    var links = document.querySelectorAll('a[data-country][data-country-code]');
    if (!links.length) return false;
    var lists = [];
    links.forEach(function (a) {
      var en = a.getAttribute('data-country');
      var ln = localName(a) || en;
      names[en] = ln;
      rev[ln] = en;
      var tn = a.firstChild;
      if (tn && tn.nodeType === 3 && tn.nodeValue.trim() !== ln) tn.nodeValue = ln + ' ';
      a.setAttribute('data-fh-name', ln);
      if (lists.indexOf(a.parentElement) === -1) lists.push(a.parentElement);
    });
    lists.forEach(function (list) {
      if (list.dataset.fhSorted === lang) return;
      var items = Array.prototype.filter.call(list.children, function (c) { return c.matches('a[data-country]'); });
      items.sort(function (x, y) { return (x.getAttribute('data-fh-name') || '').localeCompare(y.getAttribute('data-fh-name') || '', lang); });
      items.forEach(function (c) { list.appendChild(c); });
      var down = list.querySelector('.ak-currency-arrow-down');
      if (down) list.appendChild(down);
      var empty = list.querySelector('.fh-cs-empty');
      if (empty) list.appendChild(empty);
      list.dataset.fhSorted = lang;
    });
    document.querySelectorAll('.ak-dropdown-btn-currency > span').forEach(function (sp) {
      var t = sp.textContent.trim().split(' (')[0].trim();
      var en = rev[t] || t;
      if (names[en] && names[en] !== t) sp.innerHTML = sp.innerHTML.replace(t, names[en]);
    });
    return true;
  }
  /* Al elegir otro idioma en la ventana, los países pasan a ese idioma. */
  document.addEventListener('click', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('#AK-modal [data-language-code]') : null;
    if (!o) return;
    var nl = norm2(o.getAttribute('data-language-code'));
    if (nl === lang) return;
    lang = nl;
    makeDn();
    setTimeout(fhLocalizeCountries, 0);
  }, true);
  /* El botón "Visitar página web" del tema busca el país comparando el texto visible con data-country
     (en inglés). Justo antes de ese clic se pone el nombre en inglés en el botón del país, para que lo
     encuentre. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ak-visit-website-button') : null;
    if (!b) return;
    var sp = document.querySelector('.ak-dropdown-btn-currency > span');
    if (!sp) return;
    var t = sp.textContent.trim().split(' (')[0].trim();
    if (rev[t]) sp.innerHTML = sp.innerHTML.replace(t, rev[t]);
  }, true);
  document.addEventListener('click', function () { setTimeout(fhLocalizeCountries, 0); });
  var n = 0;
  var timer = setInterval(function () {
    n++;
    fhLocalizeCountries();
    if (n > 40) clearInterval(timer);
  }, 250);
})();

/* Fithome: galerías de fotos (Owl Carousel) en móvil. ak-custom.css ponía a las fotos
   "touch-action: pan-x" y "overscroll-behavior: contain": solo dejaba mover el dedo en horizontal, y al
   tocar una foto de producto no se podía hacer scroll hacia abajo. Ahora el navegador hace el scroll
   vertical y el carrusel sigue pasando las fotos en horizontal. */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body .owl-carousel, html body .owl-carousel .owl-stage-outer, html body .owl-carousel .owl-stage,' +
    'html body .owl-carousel .owl-item, html body .owl-carousel img{touch-action:pan-y!important;overscroll-behavior:auto!important}' +
    'html body #AK-Slider-Gallery-mobilepp{overflow-y:hidden!important;scroll-snap-type:none!important}' +
    /* El tema (layout/theme.liquid) pone touch-action: pan-x en el contenedor de la galería móvil al tocarla,
       y eso bloqueaba el scroll vertical: se deja siempre en pan-y. */
    'html body .ak-border-after.medium-hide.large-up-hide,html body #AK-Slider-Gallery-mobilepp,html body #AK-Slider-Gallery-mobilepp *{touch-action:pan-y!important}' +
    /* Puntos de la galería de producto: el de la foto actual se alarga en una raya. */
    'html body[class*="template--product"] [id$="__main"]:not(#fh-x) .owl-dots .owl-dot,html body[class*="template--product"] [id$="__main"]:not(#fh-x) .owl-dots .owl-dot span{transition:width .25s ease!important}' +
    'html body[class*="template--product"] [id$="__main"]:not(#fh-x) .owl-dots .owl-dot.active,html body[class*="template--product"] [id$="__main"]:not(#fh-x) .owl-dots .owl-dot.active span{width:22px!important;min-width:22px!important;border-radius:3px!important}' +
    /* La raya, del mismo color que los demás puntos. */
    'html body[class*="template--product"] [id$="__main"]:not(#fh-x) .owl-dots .owl-dot.active{background-color:#000!important;opacity:.2!important}';
  document.head.appendChild(st);
})();

/* Fithome: newsletter del pie de página (escritorio y móvil):
   - Título, una frase con el regalo de bienvenida (50 € en compras de más de 450 €) y un botón beige
     a todo lo ancho, "Subscribe now" / "Suscríbete ahora" / "Subscriu-te ara".
   - Al pulsar el botón (código del tema: muestra el formulario y oculta el botón) aparece el campo del
     email en gris y el botón beige de enviar. Usa el mismo formulario de Shopify que ya había (cliente
     con la etiqueta "newsletter"). */
(function () {
  var T = {
    en: { sub: 'and earn a 50€ discount for orders over 450€', ph: 'Enter your email address', open: 'Subscribe now' },
    es: { sub: 'Consigue 50 € de descuento en pedidos de más de 450 €', ph: 'Introduce tu email', open: 'Suscríbete ahora' },
    ca: { sub: 'Aconsegueix 50 € de descompte en comandes de més de 450 €', ph: 'Introdueix el teu email', open: 'Subscriu-te ara' }
  };
  var F = 'html body footer .footer-block--newsletter ';
  var css =
    '@media screen{' +
    F.trim() + '{display:block!important;text-align:left!important}' +
    F + '.footer-block__heading{display:block!important;width:auto!important;margin:13px 0 4px!important;padding:0!important;text-align:left!important}' +
    F + '.fh-nl-sub{display:block!important;font-size:12px;line-height:1.4;font-weight:400;color:#1c1c1c;margin:0 0 18px!important;padding:0!important;text-align:left!important}' +
    F + '.collapsible-content,' + F + '.collapsible-content__inner,' + F + '.footer__collapsible,' + F + '.footer-block__newsletter{display:block!important;width:100%!important;max-width:none!important;height:auto!important;overflow:visible!important;padding:0!important;margin:0!important;align-self:stretch}' +
    F + '.newsletter-button{display:flex;align-items:center;justify-content:center;width:100%!important;max-width:420px!important;height:42px!important;margin:0!important;padding:0 16px!important;background:#cdbb9f!important;color:#fff!important;border:0!important;border-radius:0!important;font-size:14px!important;font-weight:400!important;letter-spacing:.02em;cursor:pointer;box-sizing:border-box}' +
    F + '.newsletter-button:hover{opacity:.9}' +
    F + 'form.footer__newsletter{display:block!important;width:100%!important;max-width:420px!important;margin:0!important}' +
    F + 'form.footer__newsletter .newsletter-form__field-wrapper{width:100%!important;max-width:none!important}' +
    F + 'form.footer__newsletter .field{display:flex!important;gap:6px!important;width:100%!important;height:auto!important;align-items:stretch!important}' +
    F + 'form.footer__newsletter .field:before,' + F + 'form.footer__newsletter .field:after{display:none!important}' +
    F + 'form.footer__newsletter .field__label{display:none!important}' +
    F + 'form.footer__newsletter .field__input{flex:1 1 auto!important;width:auto!important;min-width:0!important;height:42px!important;min-height:0!important;margin:0!important;padding:0 14px!important;border:0!important;border-radius:0!important;box-shadow:none!important;background:#ebebeb!important;color:#1c1c1c!important;font-family:Manrope,var(--font-body-family),sans-serif!important;font-size:12px!important;font-weight:400!important;opacity:1!important}' +
    F + 'form.footer__newsletter .field__input:-webkit-autofill,' + F + 'form.footer__newsletter .field__input:-webkit-autofill:hover,' + F + 'form.footer__newsletter .field__input:-webkit-autofill:focus{-webkit-box-shadow:0 0 0 1000px #ebebeb inset!important;box-shadow:0 0 0 1000px #ebebeb inset!important;-webkit-text-fill-color:#1c1c1c!important;font-family:Manrope,var(--font-body-family),sans-serif!important}' +
    F + 'form.footer__newsletter .field__button{font-family:Manrope,var(--font-body-family),sans-serif!important}' +
    F + 'form.footer__newsletter .field__input::placeholder{color:#8a8a8a!important;opacity:1!important}' +
    F + 'form.footer__newsletter .field__button{position:static!important;flex:0 0 auto!important;width:auto!important;min-width:90px!important;height:42px!important;margin:0!important;padding:0 18px!important;border:0!important;border-radius:0!important;background:#cdbb9f!important;color:#fff!important;font-size:12px!important;font-weight:500!important;display:flex!important;align-items:center!important;justify-content:center!important;cursor:pointer;opacity:1!important;visibility:visible!important;transform:none!important}' +
    F + 'form.footer__newsletter .field__button svg{display:none!important}' +
    '}' +
    '@media screen and (max-width:768px){' + F + '.footer-block__heading{margin-top:13.28px!important;margin-bottom:0!important}' + F + '.fh-nl-sub{margin-top:-2.5px!important;font-size:10.8px!important}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function fhFooterNewsletter() {
    var block = document.querySelector('footer .footer-block--newsletter');
    if (!block) return false;
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var t = T[lang] || T.en;
    var desktop = true;
    var h = block.querySelector('.footer-block__heading');
    if (h && !block.querySelector('.fh-nl-sub')) {
      var p = document.createElement('p');
      p.className = 'fh-nl-sub';
      p.textContent = t.sub;
      h.insertAdjacentElement('afterend', p);
    }
    if (desktop) {
      var openBtn = block.querySelector('.newsletter-button');
      if (openBtn) openBtn.textContent = t.open;
      var input = block.querySelector('form.footer__newsletter .field__input');
      if (input) input.setAttribute('placeholder', t.ph);
    }
    return true;
  }
  var n = 0;
  var timer = setInterval(function () {
    n++;
    if (fhFooterNewsletter() || n > 40) clearInterval(timer);
  }, 250);
})();

/* Fithome: parte de abajo del footer (iconos de redes y copyright). Las dos líneas llegan de lado a
   lado de la pantalla, los iconos van pegados a la izquierda y el texto a la derecha, y el texto del
   copyright se escribe bien en cada idioma. */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body footer .footer__content-bottom-wrapper.page-width{max-width:none!important;width:100%!important;padding-left:40px!important;padding-right:40px!important;box-sizing:border-box}' +
    'html body footer .footer__copyright{width:100%!important;max-width:none!important}' +
    '@media screen and (max-width:749px){html body footer .footer__content-bottom-wrapper.page-width{padding-left:20px!important;padding-right:20px!important}}';
  document.head.appendChild(st);
  /* Las líneas son los bordes de .footer__content-bottom, que está dentro del contenedor centrado del
     footer: se estira hasta los dos lados de la ventana midiendo dónde empieza. */
  function fhStretch() {
    var b = document.querySelector('footer .footer__content-bottom');
    if (!b) return;
    b.style.removeProperty('margin-left');
    b.style.removeProperty('width');
    var l = b.getBoundingClientRect().left;
    var w = document.documentElement.clientWidth;
    b.style.setProperty('margin-left', (-l) + 'px', 'important');
    b.style.setProperty('width', w + 'px', 'important');
    b.style.setProperty('max-width', 'none', 'important');
  }
  window.addEventListener('resize', fhStretch);
  window.addEventListener('load', fhStretch);
  var TXT = { es: 'Todos los derechos reservados.', ca: 'Tots els drets reservats.', en: 'All rights reserved.' };
  function fhCopyright() {
    var c = document.querySelector('footer .copyright__content');
    if (!c) return false;
    var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    var home = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    c.innerHTML = '© ' + new Date().getFullYear() + ' <a href="' + home + '">Fithome</a>. ' + (TXT[lang] || TXT.en);
    return true;
  }
  var n = 0;
  var timer = setInterval(function () {
    n++;
    fhStretch();
    if ((document.readyState !== 'loading' && fhCopyright()) || n > 40) clearInterval(timer);
  }, 250);
})();

/* Fithome: ajustes sueltos.
   - Barra negra de arriba ("Para envíos fuera de España..."): el texto normal un poco más grueso (500).
   - Tarjetas de producto: el precio queda alineado con la primera línea del nombre (misma línea base;
     antes se centraba en vertical y en escritorio quedaba unos 8px más abajo).
   - Carrito: "Continue shopping" subrayado, botón "Apply" en Manrope, "Discount Code" un poco más grueso, y en móvil el triple de
     espacio entre "0 products" y el bloque beige del resumen. */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body .card__information .product-flex{align-items:flex-start!important}' +
    '@media screen and (min-width:750px){html body .card__information .product-flex > .card-information{margin-top:-8px!important}}' +
    '@media screen and (max-width:749px){html body .card__information .product-flex > .card-information{margin-top:-2px!important}}' +
    'html body #custom-top-announcement-bar{font-weight:500!important}' +
    'html body .ak-shopping-cart a.continue-shopping{text-decoration:underline!important;text-underline-offset:3px}' +
    'html body .ak-shopping-cart .apply-btn{font-family:Manrope,var(--font-body-family),sans-serif!important}' +
    'html body .ak-shopping-cart .ak-discount-toggle,html body .ak-shopping-cart .ak-discount-toggle span{font-weight:400!important}' +
    '@media screen and (max-width:749px){html body .ak-shopping-cart .ak-order-summary{margin-top:-26px!important}}';
  document.head.appendChild(st);
})();

/* Fithome: lista de países de la ventana "Selecciona tu país e idioma": la flecha de subir no aparece
   cuando la lista está arriba del todo, y la de bajar no aparece cuando está abajo del todo. */
(function () {
  function fhArrows() {
    document.querySelectorAll('.ak-dropdown-content-modal-currency-selector').forEach(function (list) {
      var up = list.querySelector('.ak-currency-arrow-up');
      var down = list.querySelector('.ak-currency-arrow-down');
      if (down && down !== list.lastElementChild) list.appendChild(down);
      var top = list.scrollTop <= 2;
      var bottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
      if (up) { up.style.visibility = top ? 'hidden' : ''; up.style.pointerEvents = top ? 'none' : ''; }
      if (down) { down.style.visibility = bottom ? 'hidden' : ''; down.style.pointerEvents = bottom ? 'none' : ''; }
      if (!list.dataset.fhArrows) {
        list.dataset.fhArrows = '1';
        list.addEventListener('scroll', fhArrows, { passive: true });
      }
    });
  }
  document.addEventListener('click', function () { setTimeout(fhArrows, 50); setTimeout(fhArrows, 400); });
  var n = 0;
  var timer = setInterval(function () { n++; fhArrows(); if (n > 40) clearInterval(timer); }, 250);
})();

/* Fithome: desplegable de idioma de la ventana "Selecciona tu país e idioma" (escritorio y móvil). La lista
   se abría encima del botón y lo tapaba: con un solo idioma (p. ej. Nepal -> English) parecía que no había
   desplegable. Ahora la lista se abre debajo del botón, y mientras no se ha elegido idioma el botón muestra
   "Selecciona tu idioma" (mismo color que "Selecciona tu país"). */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body #AK-modal .ak-dropdown-content-modal-language-selector{top:100%!important;border:1px solid #c4c4c4!important;border-top:0!important;box-sizing:border-box!important}';
  document.head.appendChild(st);
  var PH = ['select language', 'select you language', 'select your language', 'selecciona tu idioma', 'selecciona el teu idioma', 'select country'];
  function fhLangPlaceholder() {
    document.querySelectorAll('#AK-modal .ak-dropdown-btn-language > span').forEach(function (sp) {
      var t = sp.textContent.trim().toLowerCase();
      sp.classList.toggle('fh-placeholder', !t || PH.indexOf(t) !== -1);
    });
  }
  document.addEventListener('click', function () { setTimeout(fhLangPlaceholder, 30); setTimeout(fhLangPlaceholder, 300); });
  var n = 0;
  var timer = setInterval(function () { n++; fhLangPlaceholder(); if (n > 40) clearInterval(timer); }, 250);
})();

/* Fithome: ventana de bienvenida con el regalo del newsletter (sections/ak-newsletter-popup.liquid).
   La sección saca el título, el texto y el botón de los textos del idioma del tema, que seguían con la
   oferta antigua (20 € en compras de más de 120 €). Aquí se ponen los de la oferta actual (50 € en compras
   de más de 450 €): "50 €" un 20% más grande seguido de "Regalo de bienvenida", menos espacio entre el título y
   el texto, y el título siempre en una línea: si no cabe, la letra se reduce lo justo. */
(function () {
  var T = {
    es: { num: '50€', title: 'Regalo de bienvenida', text: 'Suscríbete a nuestra newsletter y recibe 50 € para gastar en Fithome en compras superiores a 450 € (envío no incluido).', btn: '¡Quiero mi descuento!' },
    ca: { num: '50€', title: 'Regal de benvinguda', text: 'Subscriu-te a la nostra newsletter i rep 50 € per gastar a Fithome en compres superiors a 450 € (enviament no inclòs).', btn: 'Vull el meu descompte!' },
    en: { num: '€50', title: 'Welcome Gift', text: 'Subscribe to our newsletter and receive €50 to spend at Fithome on your purchase over €450 (shipping not included).', btn: 'Get discount!' }
  };
  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  var t = T[lang] || T.en;
  var st = document.createElement('style');
  st.textContent = 'html body .newsletter-modal .popup-title{white-space:nowrap!important;overflow:hidden!important;margin-bottom:4px!important;line-height:1.2!important;align-items:baseline!important}' +
    'html body .newsletter-modal .popup-title .fh-num{font-size:1.2em;margin-right:.25em}' +
    'html body .newsletter-modal .popup-text{margin-top:0!important}';
  document.head.appendChild(st);
  function fhFit(h) {
    if (!h || !h.offsetWidth) return;
    h.style.removeProperty('font-size');
    var size = parseFloat(getComputedStyle(h).fontSize) || 24;
    var guard = 0;
    while (h.scrollWidth > h.clientWidth + 1 && size > 12 && guard < 60) {
      size -= 0.5; guard++;
      h.style.setProperty('font-size', size + 'px', 'important');
    }
  }
  function fhPopup() {
    var modals = document.querySelectorAll('.newsletter-modal');
    if (!modals.length) return false;
    modals.forEach(function (m) {
      var h = m.querySelector('.popup-title');
      var p = m.querySelector('.popup-text');
      var b = m.querySelector('.submit-button');
      if (h && !h.querySelector('.fh-num')) {
        h.innerHTML = '';
        var num = document.createElement('span');
        num.className = 'fh-num';
        num.textContent = t.num;
        h.appendChild(num);
        h.appendChild(document.createTextNode(t.title));
      }
      if (p && p.textContent !== t.text) p.textContent = t.text;
      if (b && b.textContent !== t.btn) b.textContent = t.btn;
      if (!m.dataset.fhObs && window.MutationObserver) {
        m.dataset.fhObs = '1';
        new MutationObserver(function () { setTimeout(function () { fhFit(h); }, 30); }).observe(m, { attributes: true, attributeFilter: ['style'] });
      }
      fhFit(h);
    });
    return true;
  }
  window.addEventListener('resize', function () { document.querySelectorAll('.newsletter-modal .popup-title').forEach(fhFit); });
  var n = 0;
  var timer = setInterval(function () { n++; if ((document.readyState !== 'loading' && fhPopup()) || n > 40) clearInterval(timer); }, 250);
})();

/* Fithome: ventana "Do you want to shop in another country?" (ak-custom.js): algo menos de espacio
   entre el logo y la pregunta que el original. En móvil, los botones más estrechos (más margen a los lados)
   y su texto un poco más pequeño y más fino. */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body .ak-country-popup .ak-country-popup-logo{margin-bottom:24px!important}' +
    '@media screen and (max-width:767px){html body .ak-country-popup .ak-country-popup-logo{margin-bottom:20px!important}' +
    'html body .ak-country-popup .ak-country-popup-keep,html body .ak-country-popup .ak-country-popup-change{font-size:14px!important;font-weight:400!important;width:80%!important;max-width:80%!important;margin-left:auto!important;margin-right:auto!important;display:block!important}}';
  document.head.appendChild(st);
})();

/* Fithome: fichas de producto.
   1) Sin franja blanca entre la última sección (fondo beige) y la línea de arriba del footer.
   2) El enlace "Detalles de producto" con el mismo tamaño que "Cuidado del producto" / "Envíos y
      devoluciones", y que lleve a la sección "Detalles de producto" de más abajo (el enlace apuntaba
      al identificador de sección del tema original, que cambia en cada copia del tema). */
(function () {
  var st = document.createElement('style');
  st.textContent =
    'html body[class*="template--product"] [id^="shopify-section-template--"][id$="__custom_liquid_BJQw3P"]:not(#fh-x) > div > div{padding-bottom:0!important}';
  document.head.appendChild(st);
  function fhDetailsLink() {
    var a = document.querySelector('.product-deatils a');
    if (!a) return !!document.body;
    var ref = document.querySelector('.accordion__title');
    var sp = a.querySelector('span') || a;
    if (ref) {
      var c = getComputedStyle(ref);
      ['fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'fontFamily', 'color'].forEach(function (p) {
        a.style[p] = c[p]; sp.style[p] = c[p];
      });
    }
    var target = null;
    document.querySelectorAll('main .collapsible-content__heading').forEach(function (h) {
      if (!target && h.textContent.trim().toLowerCase() === sp.textContent.trim().toLowerCase()) target = h;
    });
    if (!target) target = document.querySelector('main [id*="__collapsible_content"]');
    if (target) {
      var sec = target.closest('.shopify-section') || target;
      if (sec.id) a.setAttribute('href', '#' + sec.id);
      if (!a.dataset.fhBound) {
        a.dataset.fhBound = '1';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var head = document.querySelector('.section-header');
          var off = (head ? head.getBoundingClientRect().bottom : 0) + 10;
          var y = sec.getBoundingClientRect().top + window.pageYOffset - off;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        });
      }
    }
    return true;
  }
  var n = 0;
  var timer = setInterval(function () {
    n++;
    if ((document.readyState !== 'loading' && fhDetailsLink()) || n > 40) clearInterval(timer);
  }, 250);
  window.addEventListener('resize', fhDetailsLink);
})();

/* Fithome: carrusel de fotos del principio de la página About. ak-custom.js lo iniciaba con el
   identificador de sección del tema original (template--20614588727563), que cambia en cada copia del
   tema; aquí se inicia buscando la sección por su nombre, con las mismas opciones. */
(function () {
  function fhAboutCarousel() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.owlCarousel) return false;
    var $s = jQuery('[id^="Slider-template--"][id$="__multicolumn_3pqVFG"]');
    if (!$s.length) return true;
    if ($s.hasClass('owl-loaded')) return true;
    $s.owlCarousel({
      loop: false,
      responsiveClass: true,
      nav: false,
      dots: false,
      responsive: { 0: { items: 1 }, 600: { items: 3 }, 1000: { items: 2 } }
    });
    return true;
  }
  var n = 0;
  var t = setInterval(function () {
    n++;
    if (fhAboutCarousel() || n > 40) clearInterval(t);
  }, 250);
})();